import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { gettingAllPostalSectorsApi } from "../../services/api/authApis";
const initialState = {
  postalData: [],
  isLoading: false,
};
export const getPostalSectors = createAsyncThunk(
  "auth/postal-sectors",
  async (values, { rejectWithValue }) => {
    try {
      const data = await gettingAllPostalSectorsApi();
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postalSectorsSlice = createSlice({
  name: "postalSectorsList",
  initialState,
  reducers: {},
  extraReducers: {
    [getPostalSectors.pending]: (state) => {
      state.isLoading = true;
      return state;
    },
    [getPostalSectors.fulfilled]: (state, { payload }) => {
      state.postalData = payload.result;
      state.isLoading = false;
      return state;
    },
    [getPostalSectors.rejected]: (state, { payload }) => {
      state.isLoading = false;
      return state;
    },
  },
});

export const {} = postalSectorsSlice.actions;

export default postalSectorsSlice.reducer;
